import { AppCard, AppTab, AppTabContent, AppTabList, AppTabTrigger } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import ShiftLogo from '@frontend/public/shift_logo.svg'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { OneLoginTab } from './-components/OneLoginTab'
import { PasswordTab } from './-components/PasswordTab'

export const Route = createFileRoute('/login/')({
  // beforeLoadでのリダイレクトを削除
  // 理由: Zustand persistの初期化タイミングの問題でリダイレクトループが発生する
  // 認証済みユーザーがログインページにアクセスしても実害はない
  component: LoginPage,
})

function LoginPage() {
  useDocumentTitle('オポチュニティポータル')
  const searchParams = Route.useSearch() as { token?: string; error?: string; redirect?: string }
  const [activeTab, setActiveTab] = useState('onelogin')

  return (
    <div className='min-h-screen flex items-center justify-center'>
      <AppCard className='max-w-[560px] h-[660px]'>
        <div className='space-y-4'>
          <img src={ShiftLogo} alt='SHIFT Logo' className='h-10 mx-auto' />
          <h2 className='text-xl text-center'>案件ポータル ログイン</h2>

          <AppTab value={activeTab} onValueChange={setActiveTab}>
            <AppTabList className='w-full'>
              <AppTabTrigger value='onelogin' className='flex-1'>
                OneLogin
              </AppTabTrigger>
              <AppTabTrigger value='password' className='flex-1'>
                Password
              </AppTabTrigger>
            </AppTabList>

            <AppTabContent value='onelogin' className='space-y-4'>
              <OneLoginTab token={searchParams.token} error={searchParams.error} redirectPath={searchParams.redirect} />
            </AppTabContent>

            <AppTabContent value='password' className='space-y-4'>
              <PasswordTab redirectPath={searchParams.redirect} />
            </AppTabContent>
          </AppTab>
        </div>
      </AppCard>
    </div>
  )
}
